import React, { useState } from "react";
import { IconButton, Grid } from "@mui/material";
import { ChevronLeftRounded, ChevronRightRounded } from "@mui/icons-material";
import styles from "../../styles";
import { getImageSrc } from "../../../../utils/CommonFunction";

function ImageCarousel({ details }) {
  let images = details?.images?.length ? details.images : [];

  // Check if images array is empty, then parse primaryImage
  if (images.length === 0 && details?.primaryImage) {
    try {
      const primaryImage = JSON.parse(details.primaryImage);
      if (primaryImage?.image) {
        images = [{ id: primaryImage.id, path: primaryImage.image }];
      }
    } catch (error) {
      console.error("Error parsing primaryImage:", error);
    }
  }

  const [startIndex, setStartIndex] = useState(0);

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (startIndex < images.length - 3) {
      setStartIndex((prev) => prev + 1);
    }
  };

  return (
    <>
      <div style={{ ...styles.rowFlex, justifyContent: "space-between" }}>
        <div style={styles.section_heading}>{images.length} Photos</div>
        <div>
          <IconButton onClick={handlePrev} disabled={startIndex === 0}>
            <ChevronLeftRounded />
          </IconButton>
          <IconButton
            onClick={handleNext}
            disabled={startIndex >= images.length - 3}
          >
            <ChevronRightRounded />
          </IconButton>
        </div>
      </div>
      <div className="carousel-container">
        <div
          className="carousel-track"
          style={{
            transform: `translateX(-${startIndex * (100 / 3)}%)`,
          }}
        >
          {images.map((item) => (
            <div className="carousel-item" key={item.id}>
              <img src={getImageSrc(item?.path)} alt={`Image ${item.id}`} />
            </div>
          ))}
        </div>
      </div>

      {/* CSS Styles */}
      <style>
        {`
          .carousel-container {
            width: 100%;
            overflow: hidden;
            position: relative;
          }

          .carousel-track {
            display: flex;
            transition: transform 0.5s ease-in-out;
          }

          .carousel-item {
            flex: 0 0 calc(100% / 3);
            padding: 0 5px;
          }

          .carousel-item img {
            width: 100%;
            height: 150px;
            object-fit: cover;
            border-radius: 8px;
          }
        `}
      </style>
    </>
  );
}

export default ImageCarousel;
